// Lets a page put its own controls in the shared header, beside the page
// title, instead of floating them over its content. `AppLayout` renders the
// empty slot; it hides itself when no page fills it, so pages that do not use
// it look exactly as before.

import { useEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

export const PAGE_TOOLBAR_ID = "page-toolbar";

export function PageToolbar({ children }: { children: ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  useEffect(() => {
    setSlot(document.getElementById(PAGE_TOOLBAR_ID));
  }, []);
  return slot ? createPortal(children, slot) : null;
}
